import {
  GET_PAST_RECEIPT_REQUEST,
  GET_PAST_RECEIPT_RESPONSE,
  GET_PAST_RECEIPT_ERROR,
  SHOW_PAST_RECEIPT_MEAL_DETAILS,
  HIDE_PAST_RECEIPT_MEAL_DETAILS,
} from 'actions/pastReceipts';

const initialState = {
  loading: false,
  error: null,
  receipts: {},
  receiptMealDetails: {
    shouldDisplay: false,
    mealId: null,
    menuSlug: null,
    activeTab: '',
  },
};

export const addReceipt = (receipts, receipt) => {
  return {
    ...receipts,
    [receipt.menu.slug]: receipt,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAST_RECEIPT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PAST_RECEIPT_RESPONSE:
      return {
        ...state,
        loading: false,
        error: false,
        receipts: addReceipt(state.receipts, action.response.receipt),
      };
    case GET_PAST_RECEIPT_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case SHOW_PAST_RECEIPT_MEAL_DETAILS:
      return {
        ...state,
        receiptMealDetails: {
          shouldDisplay: true,
          mealId: action.mealId,
          menuSlug: action.menuSlug,
          activeTab: action.activeTab,
        },
      };
    case HIDE_PAST_RECEIPT_MEAL_DETAILS:
      return {
        ...state,
        receiptMealDetails: {
          shouldDisplay: false,
          mealId: null,
          menuSlug: null,
          activeTab: '',
        },
      };
    default:
      return state;
  }
};

export const selectReceiptLoading = state => state.loading;
export const selectReceipt = (state, menuSlug) => state.receipts[menuSlug];
export const selectReceiptMealDetails = state => state.receiptMealDetails;
